"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineViews = exports.routes = void 0;
const home_page_1 = require("../views/main/home-page");
const authentication_qr_scanner_1 = require("../views/authentication-qr-scanner/authentication-qr-scanner");
exports.routes = [
    {
        path: '/web',
        tag: 'home-page',
        pathParamNames: [],
        queryParamNames: [],
    },
    {
        path: '/web/authentication-qr-scanner',
        tag: 'authentication-qr-scanner',
        pathParamNames: [],
        queryParamNames: [],
    },
];
const defineViews = () => {
    (0, home_page_1.defineHomePage)('home-page');
    (0, authentication_qr_scanner_1.defineAuthenticationQrScanner)('authentication-qr-scanner');
};
exports.defineViews = defineViews;
